import MeetingTypeDetailsGuestList from "./MeetingTypeDetailsGuestList";

export default MeetingTypeDetailsGuestList;
